import formListConstants from './constants';

const formListActions = {
  formListInit: token => ({
    type: formListConstants.INITIALIZE_FORM_LIST,
    payload: {
      token
    }
  }),
  formListInitSuccess: forms => ({
    type: formListConstants.INITIALIZE_FORM_LIST_SUCCESS,
    payload: {
      forms
    }
  }),
  formListInitError: () => ({
    type: formListConstants.INITIALIZE_FORM_LIST_ERROR
  }),
  createForm: token => ({
    type: formListConstants.CREATE_FORM,
    payload: {
      token
    }
  }),
  createFormSuccess: formId => ({
    type: formListConstants.CREATE_FORM_SUCCESS,
    payload: {
      formId
    }
  }),
  createFormError: () => ({
    type: formListConstants.CREATE_FORM_ERROR
  }),
  clearNewFormId: () => ({
    type: formListConstants.CLEAR_NEW_FORMID
  })
};

export default formListActions;
